import React from 'react';
import { GalleryGrid } from 'components/gallery-grid/GalleryGrid';
import { GalleryGridItem } from 'components/gallery-grid/GalleryGridItem';
import { Divider } from 'components/elements/divider/Divider';

export const Component = () => {
  return (
    <>
      <Divider>Gallery grid with 9 or more items</Divider>
      <GalleryGrid title="Gallery title" tagline="Gallery tagline" isSlice>
        <GalleryGridItem
          size="tall"
          image={{
            url: 'https://picsum.photos/id/1021/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          image={{ url: 'https://picsum.photos/id/942/600/600?grayscale', width: 600, height: 600 }}
        />
        <GalleryGridItem
          image={{
            url: 'https://picsum.photos/id/1054/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          image={{
            url: 'https://picsum.photos/id/1064/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          size="tall"
          image={{
            url: 'https://picsum.photos/id/1031/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          image={{
            url: 'https://picsum.photos/id/1041/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          image={{
            url: 'https://picsum.photos/id/1063/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          size="tall"
          image={{
            url: 'https://picsum.photos/id/1067/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          image={{
            url: 'https://picsum.photos/id/1075/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          image={{
            url: 'https://picsum.photos/id/1078/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          image={{
            url: 'https://picsum.photos/id/1081/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          image={{ url: 'https://picsum.photos/id/111/600/600?grayscale', width: 600, height: 600 }}
        />
      </GalleryGrid>
      <Divider>Gallery grid with fewer than 9 items</Divider>
      <GalleryGrid title="Gallery title" tagline="Gallery tagline" isSlice>
        <GalleryGridItem
          size="tall"
          image={{
            url: 'https://picsum.photos/id/1021/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          image={{ url: 'https://picsum.photos/id/942/600/600?grayscale', width: 600, height: 600 }}
        />
        <GalleryGridItem
          image={{
            url: 'https://picsum.photos/id/1054/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          image={{
            url: 'https://picsum.photos/id/1064/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          size="tall"
          image={{
            url: 'https://picsum.photos/id/1031/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          image={{
            url: 'https://picsum.photos/id/1041/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          image={{
            url: 'https://picsum.photos/id/1063/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
        <GalleryGridItem
          image={{
            url: 'https://picsum.photos/id/1067/600/600?grayscale',
            width: 600,
            height: 600,
          }}
        />
      </GalleryGrid>
    </>
  );
};
